"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AcceptFlowGlobalRegistry = (function () {
    function AcceptFlowGlobalRegistry() {
        this.dataStoreInstances = [];
    }
    AcceptFlowGlobalRegistry.getInstance = function () {
        if (!AcceptFlowGlobalRegistry.instance) {
            AcceptFlowGlobalRegistry.instance = new AcceptFlowGlobalRegistry();
        }
        return AcceptFlowGlobalRegistry.instance;
    };
    AcceptFlowGlobalRegistry.prototype.registerDataStore = function (instance) {
        if (!this.dataStoreInstances.includes(instance)) {
            this.dataStoreInstances.push(instance);
        }
    };
    AcceptFlowGlobalRegistry.prototype.getAllDataStores = function () {
        return this.dataStoreInstances;
    };
    AcceptFlowGlobalRegistry.prototype.clear = function () {
        this.dataStoreInstances = [];
    };
    AcceptFlowGlobalRegistry.prototype.getLastFilledIndex = function () {
        var lastIndex = -1;
        this.dataStoreInstances.forEach(function (store) {
            if (store.accepterIndex !== null && store.accepterIndex > lastIndex) {
                lastIndex = store.accepterIndex;
            }
        });
        return lastIndex;
    };
    AcceptFlowGlobalRegistry.prototype.isSlotFilledInAllStores = function (index) {
        return this.dataStoreInstances.every(function (store) {
            var slot = store === null || store === void 0 ? void 0 : store.accepterSlots[index];
            return slot && (slot.initials || slot.signature);
        });
    };
    AcceptFlowGlobalRegistry.prototype.isSlotLockedInAnyStore = function (index) {
        return this.dataStoreInstances.some(function (store) { return store.isSlotLocked(index); });
    };
    AcceptFlowGlobalRegistry.prototype.getInitialsForSlot = function (index) {
        var _a;
        var store = this.dataStoreInstances.find(function (store) {
            var slot = store === null || store === void 0 ? void 0 : store.accepterSlots[index];
            return slot && slot.initials;
        });
        if (!store) {
            return undefined;
        }
        if (store.accepterSlots[index]) {
            return (_a = store.accepterSlots[index]) === null || _a === void 0 ? void 0 : _a.initials;
        }
        return undefined;
    };
    AcceptFlowGlobalRegistry.prototype.findFirstMissingSignature = function (slotposition) {
        var _a, _b;
        for (var i = 0; i < this.dataStoreInstances.length; i++) {
            if (((_a = this.dataStoreInstances[i]) === null || _a === void 0 ? void 0 : _a.accepterIndex) === null) {
                var store = this.dataStoreInstances[i];
                if (!store) {
                    continue;
                }
                if (store.accepterSlots[slotposition] && !((_b = store.accepterSlots[slotposition]) === null || _b === void 0 ? void 0 : _b.signature)) {
                    return { storeIndex: i, slotIndex: slotposition };
                }
            }
        }
        return null;
    };
    return AcceptFlowGlobalRegistry;
}());
exports.default = AcceptFlowGlobalRegistry;
